// extracted by mini-css-extract-plugin
export var title = "phonepe-module--title--76b00";